import React from 'react';

// Definir la interfaz de Props para incluir onAccept
interface TermsAndConditionsProps {
  onAccept: () => void;
}

const TermsAndConditions: React.FC<TermsAndConditionsProps> = ({ onAccept }) => {
  return (
    // Añadir clases para personalizar el scrollbar (requiere configuración de tailwind-scrollbar o CSS global)
    // Usaremos selectores CSS como fallback si el plugin no está
    <div className="p-6 max-w-3xl mx-auto bg-gray-800 text-gray-300 rounded-lg shadow-lg max-h-[80vh] overflow-y-auto 
                  scrollbar-thin scrollbar-thumb-purple-500 scrollbar-track-gray-700 scrollbar-thumb-rounded-full">
      {/* Estilos CSS como fallback por si tailwind-scrollbar no está */}
      <style>
        {`
          .scrollbar-thin::-webkit-scrollbar {
            width: 8px;            
          }
          .scrollbar-track-gray-700::-webkit-scrollbar-track {
            background: #374151; /* gray-700 */
            border-radius: 20px;
          }
          .scrollbar-thumb-purple-500::-webkit-scrollbar-thumb {
            background-color: #a855f7; /* purple-500 */
            border-radius: 20px;
            border: 2px solid #374151; /* gray-700 */
          }
          .scrollbar-thumb-rounded-full::-webkit-scrollbar-thumb {
             border-radius: 9999px; /* rounded-full */
          }
          /* Para Firefox (menos control) */
          .scrollbar-thin {
            scrollbar-width: thin;
            scrollbar-color: #a855f7 #374151; /* thumb track */
          }
        `}
      </style>

      <h1 className="text-2xl font-bold mb-4 text-center text-purple-400">TÉRMINOS Y CONDICIONES DE USO - CURVIA AI</h1>
      <p className="text-sm text-gray-400 mb-6 text-center">Fecha de última actualización: 01-04-2025</p>

      <p className="mb-4">
        Bienvenido a Curvia AI. Estos términos y condiciones (“Términos”) regulan el uso de nuestra plataforma de generación de currículums mediante inteligencia artificial. Al acceder o utilizar Curvia AI, el usuario acepta cumplir con estos Términos.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-purple-300">1. DEFINICIONES</h2>
      <ul className="list-disc list-inside mb-4 pl-4 space-y-1">
        <li><strong>"Curvia AI"</strong> se refiere a la plataforma que genera currículums optimizados mediante inteligencia artificial.</li>
        <li><strong>"Usuario"</strong> hace referencia a cualquier persona que acceda o utilice nuestros servicios.</li>
        <li><strong>"Servicio"</strong> hace referencia a la generación de currículums, cartas de presentación y análisis de oportunidades y debilidades laborales.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-purple-300">2. USO DEL SERVICIO</h2>
      <p className="mb-2">
        El usuario acepta utilizar Curvia AI de manera responsable y conforme a la ley. Se prohíbe estrictamente el uso del servicio para:
      </p>
      <ul className="list-disc list-inside mb-4 pl-4 space-y-1">
        <li>Crear información falsa o engañosa en currículums.</li>
        <li>Reproducir, modificar o distribuir el contenido generado sin autorización.</li>
        <li>Intentar acceder, manipular o hackear nuestros sistemas.</li>
        <li>Usar el servicio de manera que pueda afectar su disponibilidad para otros usuarios.</li>
      </ul>
      <p className="mb-4">
        Nos reservamos el derecho de suspender cuentas sin reembolso en caso de detectar abuso o uso fraudulento.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-purple-300">3. NO RESPONSABILIDAD POR DECISIONES DE EMPLEO</h2>
      <ul className="list-disc list-inside mb-4 pl-4 space-y-1">
        <li>Curvia AI no garantiza que el usuario consiga empleo.</li>
        <li>Las decisiones de contratación dependen de cada empleador, y el usuario es responsable de verificar la información de su currículum antes de enviarla.</li>
      </ul>

       <h2 className="text-xl font-semibold mt-6 mb-2 text-purple-300">4. PRECIO, PAGOS Y CAMBIOS EN EL SERVICIO</h2>
       <ul className="list-disc list-inside mb-4 pl-4 space-y-1">
         <li>Curvia AI se reserva el derecho de modificar precios, planes o funciones en cualquier momento, sin previo aviso.</li>
         <li>Si el usuario no está de acuerdo con los cambios, su única opción es dejar de usar el servicio.</li>
       </ul>

       <h2 className="text-xl font-semibold mt-6 mb-2 text-purple-300">5. REEMBOLSOS</h2>
       <ul className="list-disc list-inside mb-4 pl-4 space-y-1">
         <li>Curvia AI solo realizará reembolsos en caso de errores del sistema.</li>
         <li>Para solicitar un reembolso, el usuario deberá guardar el código de transacción o boleta y proporcionarlo para la trazabilidad del caso.</li>
         <li>No se realizarán reembolsos por mal uso del servicio o insatisfacción con los resultados.</li>
       </ul>

       <h2 className="text-xl font-semibold mt-6 mb-2 text-purple-300">6. USO DE INTELIGENCIA ARTIFICIAL Y POSIBLES ERRORES</h2>
        <ul className="list-disc list-inside mb-4 pl-4 space-y-1">
            <li>La generación de contenido es automática y puede contener errores o inexactitudes.</li>
            <li>Curvia AI no es un servicio de asesoría profesional, por lo que el usuario es responsable de revisar la información antes de su uso.</li>
        </ul>

       <h2 className="text-xl font-semibold mt-6 mb-2 text-purple-300">7. PRIVACIDAD Y USO DE DATOS</h2>
       <ul className="list-disc list-inside mb-4 pl-4 space-y-1">
            <li>Curvia AI NO recopila ni almacena información personal de los usuarios para uso comercial ni para reentrenamiento de modelos de IA.</li>
            <li>La información ingresada en la plataforma se procesa únicamente para generar el currículum y no se utiliza con otros fines.</li>
            <li>Cumplimos con normativas de protección de datos como GDPR (Europa) y la Ley de Protección de Datos Personales en Chile.</li>
        </ul>

       <h2 className="text-xl font-semibold mt-6 mb-2 text-purple-300">8. SOPORTE Y RESPONSABILIDAD DEL SERVICIO</h2>
       <ul className="list-disc list-inside mb-4 pl-4 space-y-1">
            <li>Ofrecemos soporte técnico "según disponibilidad" y no garantizamos tiempos de respuesta inmediatos.</li>
            <li>El usuario reconoce que pueden ocurrir fallas técnicas, interrupciones o errores en el servicio, y Curvia AI no se hace responsable por pérdidas económicas derivadas de estos.</li>
        </ul>

       <h2 className="text-xl font-semibold mt-6 mb-2 text-purple-300">9. JURISDICCIÓN Y LEY APLICABLE</h2>
       <p className="mb-4">
            Estos Términos se rigen por las leyes de Chile. Cualquier disputa deberá resolverse en tribunales de Santiago de Chile.
       </p>

      <p className="mt-6 font-semibold">
        Al utilizar Curvia AI, el usuario confirma haber leído y aceptado estos términos.
      </p>

      {/* Botón para aceptar los términos */}
      <div className="mt-8 text-center">
        <button
          onClick={onAccept}
          className="py-2 px-6 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 rounded-lg font-medium text-white transition-all transform hover:scale-[1.03] shadow-lg hover:shadow-purple-500/30"
        >
          Aceptar y continuar
        </button>
      </div>
    </div>
  );
};

export default TermsAndConditions; 